import {
    CreateBankDetailsActionTypes,
    DeleteBankDetailsActionTypes,
    GetBankDetailsActionTypes,
    EditBankDetailsActionTypes,
} from '../actionsTypes';

export const createBankDetailsRequest = (params) => {
    return {
        type: CreateBankDetailsActionTypes.REQUEST,
        payload: params,
    };
};

export const deleteBankDetailsRequest = (params) => {
    return {
        type: DeleteBankDetailsActionTypes.REQUEST,
        payload: params,
    };
};

export const getBankDetailsRequest = (params) => {
    return {
        type: GetBankDetailsActionTypes.REQUEST,
        payload: params,
    };
};

export const editBankDetailsRequest = (params) => {
    return {
        type: EditBankDetailsActionTypes.REQUEST,
        payload: params,
    };
};
